<div class="layout-topbar">
  <button
    #menubutton
    class="p-link layout-menu-button layout-topbar-button"
    (click)="context.onMenuToggle()"
  >
    <i class="pi pi-bars"></i>
  </button>

  <a class="layout-topbar-logo" routerLink="">
    <img class="rounded-md w-24 h-auto" src="assets/images/riotinto_logo.png" />
  </a>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="context.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>
  <span class="ml-2 font-semibold text-lg">Uplift +</span>
  <!-- <a routerLink="" class="flex items-center">
    <img
      src="assets/images/boost-logo.png"
      alt="Boost Logo"
      class="rounded-md w-20 h-auto boost-logo"
    />
  </a> -->
  <div
    #topbarmenu
    class="layout-topbar-menu"
    [ngClass]="{
      'layout-topbar-menu-mobile-active': context.state.profileSidebarVisible
    }"
  >
    <div class="flex items-center justify-between p-2 gap-6">
      <p-button
        [icon]="isDarkMode ? 'pi pi-sun' : 'pi pi-moon'"
        (onClick)="toggleDarkMode()"
        styleClass="p-button-rounded p-button-text p-button-lg"
        [ariaLabel]="
          isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'
        "
      >
      </p-button>

      <!-- <div
        #container
        class="map-button-container"
        (click)="$event.stopPropagation()"
      >
        <button
          type="button"
          class="demo-map-button"
          (click)="toggleDevelopmentMode()"
          aria-label="Toggle development mode"
        >
          Démo :
          <i
            class="pi"
            [ngClass]="isDev ? 'pi-eye-slash' : 'pi-eye'"
            style="margin-left: 4px"
          ></i>
        </button>
      </div> -->

      <!-- user info block -->
      <div
        class="flex items-center gap-2 p-2 rounded hover:bg-gray-200 cursor-pointer transition-colors"
        (click)="userInfo.toggle($event)"
      >
        <p-avatar
          icon="pi pi-user"
          shape="circle"
          size="normal"
          class="p-mr-2"
        ></p-avatar>
        <span class="font-semibold capitalize">
          {{
            userInformation?.name
              ? userInformation?.name +
                " " +
                (userInformation?.familyName || "")
              : "User Information"
          }}
        </span>
      </div>
    </div>

    <!-- The user's information panel  -->
    <!-- <p-overlayPanel #userInfo class="userInformation">
      <div class="flex flex-col">
        <div class="flex items-center gap-2 p-2 rounded-md">
          <img
            src="assets/images/riotinto_logo.png"
            alt="User Avatar"
            class="w-12 h-12 rounded-full mr-2"
          />
          <div class="flex flex-col">
            <div class="flex items-center gap-1">
              <b>Nom :</b>
              <span
                >{{ userInformation.name }}
                {{ userInformation.familyName }}</span
              >
            </div>
            <div class="flex items-center gap-1">
              <b>Email :</b>
              <span>{{ userInformation.email }}</span>
            </div>
          </div>
        </div>
        <hr class="my-2 border-t border-gray-300" />
        <div>
          <ul class="list-none">
            <li>
              <a
                href="#"
                class="flex items-center gap-2 p-2 rounded hover:bg-gray-200 cursor-pointer transition-colors"
                (click)="handleSignOut()"
              >
                <i class="pi pi-power-off"></i>
                <span>Se déconnecter</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </p-overlayPanel> -->

    <p-popover #userInfo class="userInformation">
      <div class="p-d-flex p-flex-column p-shadow-3">
        <div class="flex items-center gap-2 p-2 rounded-md">
          <p-avatar
            image="assets/images/riotinto_logo.png"
            shape="circle"
            size="large"
            class="p-mr-2"
          ></p-avatar>
          <div class="flex flex-col">
            <div class="flex items-center gap-1">
              <b>Nom :</b>
              <span
                >{{ userInformation?.name }}
                {{ userInformation?.familyName }}</span
              >
            </div>

            <div class="flex items-center gap-1">
              <b>Email :</b>
              <span>{{ userInformation?.email }}</span>
            </div>
          </div>
        </div>
        <hr class="my-custom-separator" />
        <div class="p-p-2">
          <ul class="p-menu-list">
            <li class="p-menuitem">
              <a class="p-menuitem-link" href="#" (click)="$event.preventDefault(); handleSignOut()">
                <i class="pi pi-power-off p-menuitem-icon"></i>
                <span class="p-menuitem-text">Se déconnecter</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </p-popover>
  </div>
</div>
